import { countriesConstants } from '../constants';

const initialState = {
  isLoading: false,
  countries: [] as string[],
  error: null as null | string,
};

export const countries = (state = initialState, action) => {
  switch (action.type) {
    case countriesConstants.COUNTRIES_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case countriesConstants.COUNTRIES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        countries: action.payload.countries,
      };
    case countriesConstants.COUNTRIES_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};
